<div class="container">
  <div *ngIf="useImage">
    <div class="circle"
      [ngClass]="{
        'blue-back': checked,
        'white-back': !checked
      }"
      [ngStyle]="{
        'width.px':circleSize,
        'height.px':circleSize
      }"
    >
      <svg-icon src="{{ imagePath }}" 
        class="svg-icon"
        [svgStyle]="checked
          ? {'fill': '#ffffff', 'width.px':svgSize}
          : {'fill': '#0d0d9f', 'width.px':svgSize}"
      >
      </svg-icon>
    </div>
  </div>
  <div *ngIf="!useImage">
    <div class="circle"
      [ngClass]="{
        'blue-back': checked,
        'white-back': !checked
      }"
      [ngStyle]="{
        'width.px':circleSize,
        'height.px':circleSize
      }"
    >
      <mat-icon
        [ngClass]="{
          'icon-blue-back': checked,
          'icon-white-back': !checked
        }"
        [ngStyle]="{
          'font-size.px':matFontSize
        }"
      >{{ iconName }}
      </mat-icon>
    </div>
  </div>
</div>
